import { CANADIAN_PROVINCES, type ProvinceCode } from "@reno-estimator/core";

/** Display labels for province/territory codes - UI copy only, not calculation logic. */
export const PROVINCE_LABELS: Record<ProvinceCode, string> = {
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  NT: "Northwest Territories",
  NU: "Nunavut",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  YT: "Yukon"
};

export const PROVINCE_OPTIONS: { id: ProvinceCode; label: string }[] = CANADIAN_PROVINCES.map((id) => ({
  id,
  label: PROVINCE_LABELS[id]
}));
